import angular from 'angular';
import { fineTuneTypeaheadComponent } from './fineTuneTypeaheadComponent';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/taxonomy/taxonomyModule';
import 'components/sharpr/typeahead/single/typeaheadSingleModule';

angular
	.module('sh.fineTuneTypeahead', ['sh.api', 'sh.taxonomy', 'sh.typeaheadSingle'])
	.component('shFineTuneTypeahead', fineTuneTypeaheadComponent());
